import { Station } from '@mi-front/core';
import { useField } from 'formik';
import { MentionFromCustomField } from './MentionFromCustomField';
import { MentionFromSchedulesField } from './MentionFromSchedulesField';

interface Props {
  station: Station;
}

export function MentionNameFields({ station }: Props) {
  const [{ value }] = useField('source');

  return (
    <div>
      {value === 'custom' && <MentionFromCustomField />}
      {value === 'schedules' && <MentionFromSchedulesField stationId={station.id} />}
    </div>
  );
}
